(() => {
  const selector = {
    add: '[data-nup-cart-add]',
    dock: '[data-nup-cart-dock]',
    dockCount: '[data-nup-cart-dock-count]',
    dockTotal: '[data-nup-cart-dock-total]',
    dockButton: '[data-nup-cart-dock-open]'
  };

  const formatMoney = (cents) => {
    const currency = window.Shopify?.currency?.active || 'CLP';
    try {
      return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency,
        maximumFractionDigits: 0
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return '$' + Math.round(Number(cents || 0) / 100).toLocaleString('es-CL');
    }
  };

  const fetchCart = async () => {
    const url = window.routes?.cart_url ? window.routes.cart_url + '.js' : '/cart.js';
    const response = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('cart_fetch_failed');
    return response.json();
  };

  const syncDock = async (cartData = null) => {
    const dock = document.querySelector(selector.dock);
    if (!dock) return;

    let cart = cartData;
    if (!cart || typeof cart.item_count !== 'number' || typeof cart.total_price !== 'number') {
      try {
        cart = await fetchCart();
      } catch (error) {
        return;
      }
    }

    const count = Number(cart.item_count || 0);
    dock.hidden = count === 0;

    dock.querySelectorAll(selector.dockCount).forEach((node) => {
      node.textContent = String(count);
    });

    dock.querySelectorAll(selector.dockTotal).forEach((node) => {
      node.textContent = formatMoney(cart.total_price);
    });
  };

  const refreshPageCartUx = async () => {
    const current = document.querySelector('[data-nup-cart-ux-section]');
    const sectionId = current?.dataset.sectionId;
    if (!current || !sectionId) return;

    try {
      const url = `${window.routes?.cart_url || '/cart'}?section_id=${encodeURIComponent(sectionId)}`;
      const response = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!response.ok) return;

      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const replacement = parsed.querySelector('[data-nup-cart-ux-section]');
      if (replacement) current.replaceWith(replacement);
    } catch (error) {
      // Keep the current UI if section refresh fails; native cart remains functional.
    }
  };

  const publishCartUpdate = async (payload) => {
    if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    await publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'nup-cart-ux',
      cartData: payload
    });
  };

  const addRecommendedProduct = async (button) => {
    const id = Number(button.dataset.nupCartAdd || 0);
    const productId = String(button.dataset.nupCartProductId || '');
    if (!id || button.getAttribute('aria-busy') === 'true') return;

    const originalText = button.textContent;
    let preserveFeedback = false;
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    button.textContent = '…';

    try {
      if (productId) {
        const currentCart = await fetchCart();
        const currentProductQuantity = (currentCart.items || []).reduce(
          (sum, item) => sum + (String(item.product_id) === productId ? Number(item.quantity || 0) : 0),
          0
        );
        if (currentProductQuantity >= 10) {
          preserveFeedback = true;
          button.textContent = 'Máx. 10';
          window.setTimeout(() => { button.textContent = originalText; }, 1200);
          return;
        }
      }

      const sections = ['cart-drawer', 'cart-icon-bubble'];
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{ id, quantity: 1 }],
          sections,
          sections_url: window.location.pathname
        })
      });

      const parsed = await response.json();
      if (!response.ok || parsed.status) {
        throw new Error(parsed.description || parsed.message || 'add_failed');
      }

      const drawer = document.querySelector('cart-drawer');
      if (drawer && parsed.sections && typeof drawer.renderContents === 'function') {
        drawer.renderContents(parsed);
      }

      await publishCartUpdate(parsed);
      await syncDock();
    } catch (error) {
      button.textContent = '!';
      window.setTimeout(() => {
        button.textContent = originalText;
      }, 1200);
    } finally {
      button.removeAttribute('aria-busy');
      button.disabled = false;
      if (!preserveFeedback && button.textContent !== '!') button.textContent = originalText;
    }
  };

  document.addEventListener('click', (event) => {
    const addButton = event.target.closest(selector.add);
    if (addButton) {
      event.preventDefault();
      addRecommendedProduct(addButton);
      return;
    }

    const dockButton = event.target.closest(selector.dockButton);
    if (!dockButton) return;

    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      event.preventDefault();
      drawer.open(dockButton);
    }
  });

  const subscribeToCart = () => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      syncDock(event?.cartData || null);
      refreshPageCartUx();
    });
    return true;
  };

  const observeCartBubble = () => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble || !window.MutationObserver) return;

    const observer = new MutationObserver(() => syncDock());
    observer.observe(bubble, {
      subtree: true,
      childList: true,
      characterData: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      syncDock();
      if (!subscribeToCart()) observeCartBubble();
    }, { once: true });
  } else {
    syncDock();
    if (!subscribeToCart()) observeCartBubble();
  }

  document.addEventListener('shopify:section:load', () => syncDock());
})();
